import { render, staticRenderFns } from "./Scrollable.vue?vue&type=template&id=b99450aa&scoped=true"
import script from "./Scrollable.vue?vue&type=script&lang=js"
export * from "./Scrollable.vue?vue&type=script&lang=js"
import style0 from "./Scrollable.vue?vue&type=style&index=0&id=b99450aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99450aa",
  null
  
)

export default component.exports